"use client";

import { useId, useState } from "react";
import clsx from "clsx";

import ExpandMore from "~/assets/images/helpCenter/expand-more.svg?react";

import styles from "./FAQCollapse.module.scss";

const FAQCollapse = ({ title, children, defaultOpen = false, className }) => {
  const contentId = useId();
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={clsx(styles.item, "FAQCollapse", className)}>
      <details className={styles.container} open={open} onToggle={(event) => setOpen(event.currentTarget.open)}>
        <summary className={styles.header} aria-controls={contentId} aria-expanded={open}>
          <ExpandMore className={styles.icon} aria-hidden="true" />
          <span className={styles.title}>{title}</span>
        </summary>
      </details>

      <div className={styles.contentGrid} id={contentId} aria-hidden={!open} inert={!open}>
        <div className={styles.content}>
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default FAQCollapse;
